// import { iteratorSymbol } from "immer/dist/internal";
import React, { useState } from 'react';
import {
  Table,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Modal,
  Button,
} from 'reactstrap';
import { awbGenerate } from '../action/action';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Badge } from 'reactstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
const apiUrl = process.env.REACT_APP_OMS_API;

function MarketplaceOrderItemDetails({ itemData, orderData }) {
  const [modal_standard, setmodal_standard] = useState(false);
  const [modal_large, setmodal_large] = useState(false);
  const [modal_xlarge, setmodal_xlarge] = useState(false);
  const [modal_small, setmodal_small] = useState(false);
  const [modal_center, setmodal_center] = useState(false);
  const [modal_scroll, setmodal_scroll] = useState(false);
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const dispatch = useDispatch();
  function tog_standard() {
    setmodal_standard(!modal_standard);
    removeBodyCss();
  }

  function tog_fullscreen() {
    setmodal_fullscreen(!modal_fullscreen);
    removeBodyCss();
  }

  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop);
    removeBodyCss();
  }

  function removeBodyCss() {
    document.body.classList.add('no_padding');
  }

  function tog_large() {
    setmodal_large(!modal_large);
    removeBodyCss();
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge);
    removeBodyCss();
  }

  function tog_small() {
    setmodal_small(!modal_small);
    removeBodyCss();
  }

  function tog_center() {
    setmodal_center(!modal_center);
    removeBodyCss();
  }

  function tog_scroll() {
    setmodal_scroll(!modal_scroll);
    removeBodyCss();
  }
 const generateAWB = (event) => {
     
    awbGenerate({
          params: {
            shipmentId: itemData?.[0]?.ShipmentId,
          },
          dispatch,
        });
  
    };
  const handleOrderInvoice = async (ref, country ,type) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/orders/invoice-marketplace?country=${country}&reference_no=${ref}&type=${type}`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
    };
    try {
      const response = await axios(config);
      if (response?.data?.code === 100) {
        window.location.href = response?.data?.data;
      } else {
        if (response?.data?.message) {
          toast.error(response?.data?.message, {
            style: {
              border: '1px solid #fff',
              padding: '20px',
              color: '#ffffff',
              background: '#f44336',
            },
            iconTheme: {
              primary: '#FFFAEE',
              secondary: '#f44336',
            },
          });
        }
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        dispatch(setUserData(null));
        window.location.replace('/logout');
      } else {
      }
    }
  };


  return (
    <>
      <Card className="OrderItemDetails">
        <CardHeader>
          <div className="d-flex justify-content-between align-items-center w-100">
            <CardTitle className="mb-0">ORDER ITEM DETAILS</CardTitle>

            {orderData?.Carrefour_Order && orderData.Carrefour_Order === true && orderData?.invoice_no && (
              <Button
                outline
                color="success"
                className="d-flex align-items-center gap-2"
                onClick={() =>
                  handleOrderInvoice(orderData.OrderNo, orderData?.ShippingDetails[0]?.country.toLowerCase(),'carrefour')
                }
              >
                Download Invoice <i className="bx bxs-file-pdf fs-22"></i>
              </Button>
            )}
            {orderData?.invoice_no && orderData.Carrefour_Order != true && (
              <Button
                outline
                color="success"
                className="d-flex align-items-center gap-2"
                onClick={() =>
                  handleOrderInvoice(orderData.OrderNo, orderData?.ShippingDetails[0]?.Country.toLowerCase(),'invoice')
                }
              >
                Download Invoice <i className="bx bxs-file-pdf fs-22"></i>
              </Button>
            )}
          </div>
        </CardHeader>

        {itemData !== undefined ? (
          <>
            <CardBody className="px-0">
              <div className="table-responsive dt-table">
                <Table className=" table mb-0">
                  <thead>
                    <tr>
                      <th style={{ maxWidth: 400, minWidth: 400 }}>Details</th>
                      <th style={{ maxWidth: 70, minWidth: 70 }}>Qty</th>
                      <th style={{ maxWidth: 110, minWidth: 110 }}>
                        Original Price
                      </th>
                      <th style={{ maxWidth: 110, minWidth: 110 }}>
                        Now Price
                      </th>
                      <th style={{ maxWidth: 110, minWidth: 110 }}>Discount</th>
                      <th style={{ maxWidth: 110, minWidth: 110 }}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemData?.map((item, itemInx) => {
                      let stsBtn = 'bg-soft-dark text-dark';

                      let lsStatus = '';
                      let LsStatusOption = item?.LsStatus?.toLowerCase();

                      if (item?.LsStatus === 'open' || item?.LsStatus === '') {
                        stsBtn = 'bg-dark';
                        lsStatus = 'Pending';
                      } else {
                        lsStatus = item?.LsStatus;
                      }
                      if (LsStatusOption === 'picked') {
                        stsBtn = 'bg-warning';
                        lsStatus = 'Picked';
                      } else {
                        lsStatus = item?.LsStatus;
                      }

                      if (item?.LsStatus === '0' || item?.LsStatus === '') {
                        if (item?.LsStatus === 'Canceled') {
                          stsBtn = 'bg-danger';
                          lsStatus = 'Canceled';
                        } else if (LsStatusOption === 'pending_payment') {
                          lsStatus = 'Pending Payment';
                          stsBtn = 'bg-danger';
                        } else if (LsStatusOption === 'pending') {
                          lsStatus = 'Pending';
                          stsBtn = 'bg-soft-dark';
                        } else {
                          lsStatus = 'New';
                          stsBtn = 'bg-soft-dark';
                        }
                      } else {
                        lsStatus = item?.LsStatus;
                      }
                      if (LsStatusOption === 'posted') {
                        stsBtn = 'bg-primary';
                        lsStatus = 'Posted';
                      } else if (LsStatusOption === 'confirmed') {
                        stsBtn = 'bg-primary';
                        lsStatus = 'Confirmed';
                      } else if (
                        LsStatusOption === 'delivered' ||
                        LsStatusOption === 'completed'
                      ) {
                        stsBtn = 'bg-success';
                      }

                      if (
                        item?.LsStatus === 'canceled' ||
                        item?.LsStatus === 'Canceled' ||
                        item?.LsStatus === 'cancel' ||
                        item?.LsStatus === 'Cancel' ||
                        LsStatusOption === 'pending_payment'
                      ) {
                        lsStatus = 'Canceled';
                        stsBtn = 'bg-danger';
                      }
                      return (
                        <tr key={itemInx}>
                          <td className="table-bordered">
                            <div style={{ gap: '1rem' }}>
                              <img
                                alt=""
                                width="100"
                                height="100"
                                className="img-thumbnail1"
                                src={item?.Image}
                                style={{ maxWidth: '100px' }}
                              />

                              <div
                                className="d-flex flex-column"
                                style={{ maxWidth: '75%' }}
                              >
                                <span>{item?.Name}</span>

                                <span>Sku : {item?.Sku}</span>

                                <span>
                                  Delivery Date : <b>{item?.DeliveryDate}</b>
                                </span>

                                <span>
                                  Status :{' '}
                                  <Badge className={` ${stsBtn} me-3`}>
                                    {' '}
                                    {lsStatus}
                                  </Badge>
                                </span>
                                <span>
                                  LS Ref : <b>{item?.LsOrderRef}</b>
                                </span>
                                {item?.ShipmentId && (
                                  <Button
                                    color="primary"
                                    size="sm"
                                    className="mt-2 align-self-start"
                                    onClick={() => {
                                      let baseUrl = process.env.REACT_APP_OMS_API;
                                      let baseUrl1 = '';
                                      // Remove trailing /api or /api/ if present
                                      baseUrl1 = baseUrl?.replace(/\/api\/?$/, '');
                                      console.log('baseUrl', baseUrl);
                                      const shipmentId = item?.ShipmentId;
                                      if (baseUrl && shipmentId) {
                                        window.open(`${baseUrl1}/single-awb/${shipmentId}`, '_blank');
                                      } else {
                                        toast.error('AWB download URL or ShipmentId missing');
                                      }
                                    }}
                                  >
                                    Download AWB <i className="bx bx-download"></i>
                                  </Button>
                                )}
                              </div>
                            </div>
                          </td>
                          <td
                            className="table-bordered align-middle"
                            style={{ textAlign: 'center' }}
                            nowrap="nowrap"
                          >
                            {item?.Qty}
                          </td>
                          <td
                            className="table-bordered align-middle"
                            style={{ textAlign: 'center' }}
                            nowrap="nowrap"
                          >
                            {item?.Currency} {Number(item?.WasPrice).toFixed(2)}
                          </td>
                          <td
                            className="table-bordered align-middle"
                            style={{ textAlign: 'center' }}
                            nowrap="nowrap"
                          >
                            {item?.Currency} {item?.NowPrice}
                          </td>
                          <td
                            className="table-bordered align-middle"
                            style={{ textAlign: 'center' }}
                            nowrap="nowrap"
                          >
                            {item?.Currency}{' '}
                            {item?.Discount === '' || item?.Discount === null
                              ? '0.00'
                              : item?.Discount}
                          </td>
                          <td
                            className="table-bordered align-middle"
                            style={{ textAlign: 'center' }}
                            nowrap="nowrap"
                          >
                            {item?.Currency}{' '}
                            {Number(item?.TotalPrice).toFixed(2)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </>
        ) : (
          <>
            <CardBody>
              <Skeleton count={6} />
            </CardBody>
          </>
        )}
      </Card>
    </>
  );
}
export default MarketplaceOrderItemDetails;
